// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"623c7e14","498":"4b684bb0"}[chunkId] + ".chunk.css";
};